import { useState } from 'react';
import { Button } from 'semantic-ui-react';
import EditUsersModal from '../../../containers/auth/EditUsers';

const UserRow = (props) => {
  const { user, getUsers } = props;
  const [openModal, set_openModal] = useState(false);

  const { name, email } = user;

  return (
    <tr>
      <td>
        <p style={{ margin: '0' }}>{name}</p>
      </td>
      <td>
        <p style={{ margin: '0' }}>{email}</p>
      </td>
      <td>
        <Button onClick={() => set_openModal(true)}>Ver</Button>
        {openModal && (
          <EditUsersModal
            user={user}
            getUsers={getUsers}
            openModal={openModal}
            set_openModal={set_openModal}
          />
        )}
      </td>
    </tr>
  );
};

export default UserRow;
